import React, { useState } from 'react';
import { Button, Loader, Modal } from '../../../../Components/uielements';

import {
  ModalButtonWrapper,
  ModalWrapper,
  ModalGap,
} from '../../../../services/settings/appStyle/global.style';
import { useQuery } from 'react-query';
import { documentView } from '../../../../services/bioplus-services/library';
import { ModalLabel } from '../../UserV2/user.style';
import { ErrorSvg } from '../../../../Components/icons';

const DocumentView = ({ onClose, companyId, data }) => {
  const [error, setError] = useState();

  useQuery(
    ['viewDoc'],
    () =>
      documentView(companyId, {
        documentName: data?.documentName,
      }),
    {
      onSuccess: (data) => {
        onClose();
        window.open(data, '_blank');
      },
      onError: (error) => setError(error),
    }
  );

  return (
    <>
      <Modal isOpen={true} onClose={onClose}>
        {!error ? (
          <ModalWrapper>
            <ModalGap>
              <Loader isNotRequiredLoadingText={true} />
              <ModalLabel>Sit back and relax, we are generating the document view.</ModalLabel>
            </ModalGap>
          </ModalWrapper>
        ) : (
          <ModalWrapper>
            <>
              <ErrorSvg
                style={{ width: '60px', height: '60px', justifySelf: 'center', paddingTop: '20px' }}
              />
              <ModalLabel>
                Oops! Unable to provide the document view. Please try again later.
              </ModalLabel>
            </>
            <ModalButtonWrapper>
              <Button varient="normal" onClick={onClose}>
                Close
              </Button>
            </ModalButtonWrapper>
          </ModalWrapper>
        )}
      </Modal>
    </>
  );
};

export default DocumentView;
